import { configureStore } from '@reduxjs/toolkit';

import messageReducer from '../messages/messageSlice';

export default configureStore({
	reducer: {
		messages: messageReducer,	  
	},
});